import { createAction } from 'src/lib/createAction';

export const tutorialActions = {
  reset: createAction('tutorial/reset')(),
  nextStep: createAction('tutorial/nextStep')<number>(),
  setHasApp: createAction('tutorial/hasApp')<boolean>(),
  setIsMobile: createAction('tutorial/isMobile')<boolean>(),
};
